export const colorPrimary = {light: "#405162", main: "#2c353c", dark: "#222b34"};
export const colorSecondary = {light: "#63acee", main: "#4ca0eb", dark: "#1e88e5"};
export const colorLightGreen = {light: "#4ad7ae", main: "#2bc397", dark: "#26ae87"};
export const colorTomatoRed = {light: "#ee91a8", main: "#e86584", dark: "#e44f73"};
export const colorLemom = {light: "#edd373", main: "#e7c546", dark: "#ddb51d"};
export const colorOrange = {light: "#fda965", main: "#fc9b4c", dark: "#fc8d33"};
export const colorPurple = {light: "#b2a1cb", main: "#9780b9", dark: "#8970b0"};
export const colorGrey = {light: "#6a859d", main: "#5e788f", dark: "#546b80"};